import { get } from 'lodash';
import { connect } from 'react-redux';

import BreadcrumbsComponent from 'components/PdpBreadcrumbs';
import { BREADCRUMB_NAVIGATION_LINK_TYPES } from 'constants/breadcrumbNavigation';
import * as actions from 'state/actions';
import { getCurrentProduct, isSalePdp } from 'state/selectors/pdp';
import BreadcrumbsUtil from 'utils/Breadcrumbs';
import Log from 'utils/Log';

import { BREADCRUMB_TRAIL_REMAPPINGS } from './constants';

const mapStateToProps = state => {
  const type = BREADCRUMB_NAVIGATION_LINK_TYPES.PRODUCT;
  const currentProduct = getCurrentProduct(state);
  const handle = get(currentProduct, 'master');

  const { breadcrumbTrail } = BreadcrumbsUtil.getBreadcrumbTrail({ type, handle });

  let remappedBreadcrumbTrail = null;
  if (isSalePdp() && breadcrumbTrail.length) {
    try {
      const topLevelCategoryNode = breadcrumbTrail[1];

      if (topLevelCategoryNode) {
        const remappedBreadcrumbs = BREADCRUMB_TRAIL_REMAPPINGS[topLevelCategoryNode.linkUrl];
        const currentProductNode = breadcrumbTrail[breadcrumbTrail.length - 1];

        if (remappedBreadcrumbs && currentProductNode) {
          const remappedResult = BreadcrumbsUtil.getBreadcrumbTrail(remappedBreadcrumbs);

          const remappedCategoryNode =
            remappedResult.breadcrumbTrail[remappedResult.breadcrumbTrail.length - 1];

          if (remappedCategoryNode.label) {
            remappedBreadcrumbTrail = [...remappedResult.breadcrumbTrail, currentProductNode];
          }
        }
      }
    } catch (e) {
      Log.error('Failed to re-map PDP Breadcrumbs for sale', e);
      remappedBreadcrumbTrail = null;
    }
  }

  return {
    breadcrumbTrail: remappedBreadcrumbTrail || breadcrumbTrail,
  };
};

const mapDispatchToProps = dispatch => ({
  trackNavigation: url => {
    dispatch(actions.trackBreadcrumbNavigation(url));
    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsComponent);
